module.exports = __webpack_public_path__ + "img/jiuzhang-back-phone@2x.734c0210.png";